const historyTabs = (t, type) => {
  const items = type === 'creations'
    ? t('historyTab.creations.tabs', { returnObjects: true })
    : t('historyTab.models.tabs', { returnObjects: true });
  return items;
};
export default historyTabs;
